export default __webpack_public_path__ + "static/media/empty-betslip.d81302ee.png";